var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.814 25.2001C16.9544 25.4433 17.1564 25.6453 17.3996 25.7857C17.6428 25.9261 17.9187 26 18.1996 26C18.4804 26 18.7563 25.9261 18.9995 25.7857C19.2428 25.6453 19.4447 25.4433 19.5852 25.2001",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.209 20.6608C11.1045 20.7754 11.0355 20.9178 11.0105 21.0709C10.9855 21.2239 11.0054 21.3809 11.068 21.5228C11.1305 21.6647 11.233 21.7853 11.3628 21.87C11.4927 21.9548 11.6444 21.9999 11.7994 22.0001H24.5995C24.7545 22.0001 24.9062 21.9551 25.0362 21.8705C25.1661 21.786 25.2687 21.6655 25.3314 21.5237C25.3941 21.3819 25.4143 21.2249 25.3894 21.0719C25.3646 20.9188 25.2958 20.7763 25.1915 20.6616C24.1275 19.5648 22.9995 18.3992 22.9995 14.8C22.9995 13.527 22.4938 12.3061 21.5936 11.4059C20.6934 10.5057 19.4725 10 18.1994 10C16.9264 10 15.7055 10.5057 14.8053 11.4059C13.9051 12.3061 13.3994 13.527 13.3994 14.8C13.3994 18.3992 12.2706 19.5648 11.209 20.6608Z",
    stroke: "#333333",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.71c285d47541500d7c0ee22b486efe6e.svg";
export { ForwardRef as ReactComponent };